import { CloseIcon } from "components/common/Icons/CloseIcon";
import { Modal } from "components/common/Modal/Modal";
import { Translate } from "components/common/Translate/Translate";
import { Options } from "./Options/Options";
import { useTextBoxSettings } from "./useTextBoxSettings";

export const TextBoxSettings = () => {
    const { activeTextBoxId, textBox, width, handleOutsideClick } = useTextBoxSettings();
    if (!textBox || width >= 1024) return null;
    return (
        <Modal
            isOpen={!!activeTextBoxId}
            close={handleOutsideClick}
            backgroundScroll={true}
            overlayBackground="bg-transparent"
            interactiveBackground={true}
        >
            <div className="mt-auto w-full pointer-events-auto text-black" onClick={(e) => e.stopPropagation()}>
                <div className="h-full px-6 pb-4 flex flex-col gap-6 bg-white dark:bg-darkSurface-200 rounded-t-3xl pt-6 shadow-[0_-15px_60px_-15px_rgba(0,0,0,0.3)] text-black dark:text-white">
                    <div className="relative flex justify-around items-center">
                        <div className="text-lg mx-auto">
                            <Translate keyName="text-editor" />
                        </div>
                        <Close onClick={handleOutsideClick} />
                    </div>
                    <Options textBox={textBox} />
                </div>
            </div>
        </Modal>
    );
};

interface CloseProps {
    onClick: () => void;
}

const Close = ({ onClick }: CloseProps) => (
    <div
        className="absolute right-0 top-0 bottom-0 flex items-center justify-center bg-irGray-300 dark:bg-darkSurface-300 rounded-full w-6 h-6"
        onClick={onClick}
    >
        <CloseIcon />
    </div>
);
